export default __webpack_public_path__ + "static/media/497.51697429.gif";